// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f659455","388":"ba401119","732":"29fa14ce","977":"0491d24e"}[chunkId] + ".chunk.js";
};